import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const FloatingButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when scrolled past hero section
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  if (!isVisible) return null;

  return (
    <a
      href="tel:2699106622"
      className="fixed bottom-6 right-6 z-50 md:hidden bg-ocean-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-2xl hover:bg-ocean-700 transition-all duration-300 animate-bounce"
      aria-label="Call Now"
    >
      <SafeIcon icon={FiIcons.FiPhoneCall} className="text-2xl" />
    </a>
  );
};

export default FloatingButton;